import { render, staticRenderFns } from "./ProductDocumentsModal.vue?vue&type=template&id=4db98724&scoped=true&"
import script from "./ProductDocumentsModal.vue?vue&type=script&lang=js&"
export * from "./ProductDocumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductDocumentsModal.vue?vue&type=style&index=0&id=4db98724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db98724",
  null
  
)

export default component.exports